import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import App from 'antd/lib/app';
import { ICreateSavedFilter, ISavedFilter } from '../../components/sidebar-filters/saved-filter/interface';
import { QueryKey } from '../../query-client';
import { createSavedFilter, deleteSavedFilter, fetchSavedFilters, updateSavedFilter } from './index';

export const useSavedFilterListQuery = ({ subType }: { subType: string }, options = {}) => {
    return useQuery<ISavedFilter[], Error>({
        queryKey: [QueryKey.SAVED_FILTERS, subType],
        queryFn: ({ signal }) => fetchSavedFilters({ subType }, signal),
        ...options,
    });
};

export const useSavedFilterCreateMutation = () => {
    const { notification } = App.useApp();
    const queryClient = useQueryClient();

    return useMutation<void, Error, ICreateSavedFilter>(createSavedFilter, {
        onSuccess: async () => {
            await queryClient.invalidateQueries([QueryKey.SAVED_FILTERS]);
            notification.success({ key: 'save-filter-success', message: 'Filter saved successfully' });
        },
    });
};

export const useSavedFilterUpdateMutation = () => {
    const { notification } = App.useApp();
    const queryClient = useQueryClient();

    return useMutation<void, Error, ICreateSavedFilter>(updateSavedFilter, {
        onSuccess: async () => {
            await queryClient.invalidateQueries([QueryKey.SAVED_FILTERS]);
            notification.success({ key: 'save-filter-success', message: 'Filter updated successfully' });
        },
    });
};

export const useSavedFilterDeleteMutation = () => {
    const { notification } = App.useApp();
    const queryClient = useQueryClient();

    return useMutation<void, Error, number>(deleteSavedFilter, {
        onSuccess: async () => {
            await queryClient.invalidateQueries([QueryKey.SAVED_FILTERS]);
            notification.success({ key: 'delete-filter-success', message: 'Filter deleted successfully' });
        },
    });
};
